import { render, staticRenderFns } from "./TextSnippets.vue?vue&type=template&id=3665c424&scoped=true"
import script from "./TextSnippets.vue?vue&type=script&lang=js"
export * from "./TextSnippets.vue?vue&type=script&lang=js"
import style0 from "./TextSnippets.vue?vue&type=style&index=0&id=3665c424&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3665c424",
  null
  
)

export default component.exports